import { Box, Button, Grid, Popover, Stack, Tooltip, Typography } from "@mui/material";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";

interface Props {
  anchorEl?: HTMLElement;
  ledgerCaption: string;
  removedItems: string[];
  onCancel: () => void;
  onConfirm: () => void;
}

const visibleItemCount = 5;

const ListLedgerChangePopover = ({ anchorEl, ledgerCaption, removedItems, onCancel, onConfirm }: Props) => {
  const visibleItems = removedItems.slice(0, visibleItemCount);
  const remainingItems = removedItems.slice(visibleItemCount);

  return (
    <Popover
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={onCancel}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      slotProps={{
        paper: {
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 1px 2px rgba(0,0,0,0.32))",
            maxWidth: 340,
            mt: 1,
            ml: -0.4,
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              left: 0,
              width: 12,
              height: 12,
              bgcolor: "background.paper",
              transform: "translateY(-50%) translateX(100%) rotate(45deg)",
            },
          },
        },
      }}
    >
      <Stack spacing={1} sx={{ p: 2, width: "100%" }}>
        <Typography variant="subtitle1">Change ledger?</Typography>
        <Typography color="secondary">
          Changing to {ledgerCaption} will remove configured items that are unavailable for this ledger:
        </Typography>
        <Box component="ul" sx={{ my: 0, pl: 2.5 }}>
          {visibleItems.map((item) => (
            <Typography component="li" variant="caption" key={item}>
              {item}
            </Typography>
          ))}
          {remainingItems.length > 0 && (
            <Tooltip
              arrow
              placement="right"
              title={
                <Stack spacing={0.25}>
                  {remainingItems.map((item) => (
                    <Typography variant="caption" key={item}>
                      {item}
                    </Typography>
                  ))}
                </Stack>
              }
            >
              <Typography
                component="li"
                variant="caption"
                sx={{ cursor: "help", textDecoration: "underline dotted", textUnderlineOffset: 2 }}
              >
                {remainingItems.length} more
              </Typography>
            </Tooltip>
          )}
        </Box>
        <Grid container sx={{ gap: 1, pt: 1, width: "100%" }}>
          <HorizontalFill />
          <Button variant="outlined" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onConfirm}>
            Change Ledger
          </Button>
        </Grid>
      </Stack>
    </Popover>
  );
};

export default ListLedgerChangePopover;
